import { Settings } from '$/io.ox/core/settings'

export const defaults = {
  apiModule: 'plugins/mx-checker',
  suppress: false,
  suppressDays: 1,
  ignoreEmptyActionUrl: false,
  checkSpf: true
}

export const settings = new Settings('io.ox/mx-checker', () => defaults)
